<template>
  <CategoryForm />
</template>

<script>
import CategoryForm from '@/layouts/components/form/CategoryForm.vue'

export default {
  components: { CategoryForm },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
